import { BasketProductDto, PeppolFormDataResponse, ProductBasketDto } from '@api/*';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ProductBasketActions = createActionGroup({
  source: 'ProductBasket',
  events: {
    'Add Basket Product': props<{ basketProduct: BasketProductDto }>(),
    'Add Basket Product Success': props<{ productBasket: ProductBasketDto }>(),
    'Add Basket Product Failure': props<{ error: string }>(),

    'Update Basket Product Quantity': props<{ basketProductId: number; quantity: number }>(),
    'Update Basket Product Quantity Success': props<{ basketProduct: BasketProductDto }>(),
    'Update Basket Product Quantity Failure': props<{ error: string }>(),

    'Remove Basket Product': props<{ basketProductId: number }>(),
    'Remove Basket Product Success': props<{ basketProductId: number }>(),
    'Remove Basket Product Failure': props<{ error: string }>(),

    'Get Punchout Form Data': emptyProps(),
    'Get Punchout Form Data Success': props<{ punchOutFormData: PeppolFormDataResponse }>(),
    'Get Punchout Form Data Failure': props<{ error: string }>(),

    'Get Session ID Basket': emptyProps(),
    'Get Session ID Basket Success': props<{ productBasket: ProductBasketDto }>(),
    'Get Session ID Basket Failure': props<{ error: string }>(),
  }
});
